import { TFunction } from 'i18next';

export enum ControllerExceptionCodes {
  Code_General_NotAuthorized = 'IP0001',
  Code_General_NotFound = 'IP0002',
  Code_Risk_DuplicateCode = 'RISK0001',
  Code_Asset_DuplicateCode = 'ASSET0001',
  Code_Auth_TenantAlreadyRegistered = 'AUTH0001',
  Code_Auth_TooManyLicensesAssigned = 'AUTH0002',
  Code_Auth_CannotRemoveLastAdmin = 'AUTH0003',
  Code_Auth_CannotUnlicenseLastUser = 'AUTH0004',
  Code_Auth_CannotSearchNoSites = 'AUTH0005',
  Code_Auth_NewPermissionsRequired = 'AUTH0006',
  Code_Group_DoesNotExist = 'GROUP0001',
  Code_ProcessingActivity_DuplicateCode = 'PA0001',
  Code_Graph_FileLocked = 'GRAPH0001',
  Code_Planner_InvalidConfig = 'PLANNER0001',
  Code_Task_CanOnlyMoveToArchivedFromCompletedAndRejected = 'TASK0001',
  Code_Task_CannotDeleteTemplateOfIntegration = 'TASK0002',
  Code_Task_IntegrationTemplateMustHaveTagControlFinding = 'TASK0003',
  Code_EC_AlreadyRunning = 'EC0001',
  Code_EC_CanOnlyReprocessDeadRuns = 'EC0002',
  Code_Tag_MustHaveTagsForEachSystemType = 'TAG0001',
  Code_Task_StartDateBeforeLastCompletedInstance = 'TASK0004',
  Code_Task_EndDateAfterNextInstance = 'TASK0005',
  Code_Integration_MissingGraphPermission = 'INTEGRATION0001',
  Code_Integration_NoGraphPermissions = 'INTEGRATION0002',
  Code_Integration_AuthFailureGeneric = 'INTEGRATION0003',
  Code_Integration_OAuthNotConfigured = 'INTEGRATION0004',
  Code_Integration_GrantStoredTestFailed = 'INTEGRATION0005',
  Code_Report_SharePointReportsDisabled = 'REPORT0001',
  Code_Report_SharePointPermissionsMissing = 'REPORT0002',
  Code_Report_ExportSourceLegacyWord = 'REPORT0003',
  Code_Report_ExportSourceProtected = 'REPORT0004',
  Code_Report_ExportSourceUnreadable = 'REPORT0005',
  Code_Report_PdfNotAvailable = 'REPORT0006',
  Code_TaskView_DuplicateName = 'TASKVIEW0001',
  Code_Billing_SubscriptionRequired = 'BILLING0001',
  Code_Library_TargetNotFound = 'LIBRARY0001',
  Code_Library_NoWritePermission = 'LIBRARY0002',
  Code_Library_TargetLocked = 'LIBRARY0003',
  Code_Library_DuplicateExternalId = 'LIBRARY0004',
  Code_Library_ConnectionNotInherited = 'LIBRARY0005',
  Code_Library_UploadTypeNotAllowed = 'LIBRARY0006',
  Code_Library_UploadTooLarge = 'LIBRARY0007',
  Code_Asset_DuplicateExternalId = 'ASSET0002',
  // PLAN-073: add from the catalogue and the supplier investigations. The messages come with the screens that raise them
  Code_Asset_TooManyTemplates = 'ASSET0003',
  Code_Asset_DuplicateName = 'ASSET0004',
  Code_Asset_NotASupplier = 'ASSET0005',
  // A supplier's certificate upload (PLAN-CTI-098): the plan token is unknown, expired, used or of another asset; the
  // asset has no compliance report yet
  Code_Asset_CompliancePlanExpired = 'ASSET0007',
  Code_Asset_ComplianceNoReport = 'ASSET0008',
  Code_Task_DuplicateExternalId = 'TASK0006',
  Code_Process_DuplicateExternalId = 'PROCESS0001',
  Code_Objective_DuplicateExternalId = 'OBJECTIVE0001',
  Code_Risk_DuplicateExternalId = 'RISK0002',
  Code_OrgUnit_BindNotAllowed = 'ORGUNIT0001',
  Code_OrgUnit_BindDirectoryNotFound = 'ORGUNIT0003',
  Code_OrgUnit_BindContainerNotAllowed = 'ORGUNIT0005',
  Code_OrgUnit_BindDirectoryInUse = 'ORGUNIT0006',
  Code_Task_EndDateAfterDeadline = 'TASK0007',
  Code_Standard_MaxStandardsReached = 'STANDARD0001',
  //Appointing a consultant is how a customer chooses its partner, so these are refusals a customer admin sees.
  //Message carries the email, respectively the name of the partner already assigned.
  Code_Auth_ConsultantNotAtPartner = 'AUTH0007',
  Code_Auth_ConsultantAtMultiplePartners = 'AUTH0008',
  Code_Auth_PartnerAlreadyAssigned = 'AUTH0009',
  Code_Auth_PartnerCannotAppointConsultant = 'AUTH0010',
  Code_Auth_CannotAssignRoleToYourself = 'AUTH0011',
  Code_Backup_AlreadyInProgress = 'BACKUP0001',
  Code_Backup_ManualQuotaReached = 'BACKUP0002',
  Code_Backup_NotReadyToRestore = 'BACKUP0003',
  Code_Backup_NotIncludedInSubscription = 'BACKUP0004',
  Code_Backup_DeleteTargetNotAllowed = 'BACKUP0006',
  Code_Backup_PointInTimeUnavailable = 'BACKUP0007',
  Code_Backup_HistoryUnavailable = 'BACKUP0008',
  Code_Backup_TenantHeldByFailedRestore = 'BACKUP0009',
  Code_InternalAudit_TeamIncomplete = 'AUDIT0001',
  Code_InternalAudit_ScopeEmpty = 'AUDIT0002',
  Code_InternalAudit_MeetingOrganizerMismatch = 'AUDIT0003',
  Code_InternalAudit_OpenExecutionTasks = 'AUDIT0004',
  Code_InternalAudit_UnassignedScopeItems = 'AUDIT0005',
  Code_InternalAudit_UnassessedScopeItems = 'AUDIT0006',
  Code_InternalAudit_ResultsFrozen = 'AUDIT0007',
  Code_InternalAudit_AssigneeNotAuditee = 'AUDIT0008',
  Code_InternalAudit_Published = 'AUDIT0009',
  Code_InternalAudit_ResetNotAllowed = 'AUDIT0010',
  Code_InternalAudit_UnassignedOpenTasks = 'AUDIT0011',
  Code_InternalAudit_StartDateRequired = 'AUDIT0012',
  Code_InternalAudit_PlanOutsidePeriod = 'AUDIT0013',
  Code_InternalAudit_UnknownProcedure = 'AUDIT0014',
  Code_InternalAudit_UnknownState = 'AUDIT0016',
  Code_InternalAudit_StatusStepSkipped = 'AUDIT0017',
  Code_InternalAudit_ReportingIntegrationOff = 'AUDIT0018',
  Code_InternalAudit_FindingsMissing = 'AUDIT0019',
  Code_InternalAudit_ReportMissing = 'AUDIT0020',
  Code_InternalAudit_ReportOutdated = 'AUDIT0021',
  Code_InternalAudit_InvalidScopeOrder = 'AUDIT0022',
  Code_InternalAudit_TeamPermissions = 'AUDIT0023',
  Code_InternalAudit_ProcedureContentInvalid = 'AUDIT0024',
  Code_InternalAudit_ProcedureFormLocked = 'AUDIT0025',
  Code_InternalAudit_NothingAudited = 'AUDIT0026',
  Code_InternalAudit_StandardsRequired = 'AUDIT0027',
  Code_InternalAudit_CriteriaChanged = 'AUDIT0028',
  Code_InternalAudit_ImprovementAlreadyApplied = 'AUDIT0029',
  Code_InternalAudit_CriterionAnswerRoleInvalid = 'AUDIT0031',
  // The audit report folder: a folder of the audit's name exists (a 409 of the move to Preparing, with the
  // folderName), the audit reports location is not set, or it cannot be written (blockers of that move)
  Code_InternalAudit_ReportFolderExists = 'AUDIT0033',
  Code_InternalAudit_ReportLocationMissing = 'AUDIT0034',
  Code_InternalAudit_ReportLocationNoWriteAccess = 'AUDIT0035',
  // PLAN-075: generic criteria sets. The messages come with the screens that raise them (plan Task 16)
  Code_InternalAudit_CriteriaRevertBlocked = 'AUDIT0032',
  Code_InternalAudit_CriteriaCopyFirst = 'AUDIT0036',
  Code_InternalAudit_GenericSetDeleteRefused = 'AUDIT0037',
  Code_InternalAudit_EvidenceTaskOnGenericSet = 'AUDIT0038',
  Code_InternalAudit_NoCriteriaSet = 'AUDIT0039',
  Code_InternalAudit_AutomationNotForFamily = 'AUDIT0040',
  Code_Task_CannotDeleteEvidenceTask = 'TASK0008',
  Code_Task_FormIncomplete = 'TASK0009',
  Code_Task_FormFamilyHasProducers = 'TASK0010',
  Code_Task_ReservedExternalId = 'TASK0011',
  Code_Task_CalendarUnavailable = 'TASK0012',
  Code_Task_RecurringNormalTask = 'TASK0015',
  Code_Task_NotStartedYet = 'TASK0017',
  Code_Task_TypeConversionNotAllowed = 'TASK0016',
  Code_KPI_UsedInForm = 'KPI0001',
  Code_Package_AlreadyInstalling = 'PACKAGE0001',
  Code_Package_RecurringNormalTask = 'PACKAGE0002',
  Code_Onboarding_AlreadyRunning = 'ONBOARDING0001',
  Code_AIModel_Invalid = 'AIMODEL0001',
  Code_AIModel_NotReady = 'AIMODEL0002',
  Code_AIModel_InternetResearchOff = 'AIMODEL0003',
  // A general knowledge skill body refused in Tenant Admin; the message lists every problem and is shown as is.
  Code_AISkill_Invalid = 'AISKILL0001',
  //the organization's AI credits are used up; the API answers it with 402, not 400
  Code_Credit_NoCreditsAvailable = 'CREDIT0001',
  // The SkillControl sign-in of the AI assistant (API enum 191-192 and 194-197; 193 was retired before 7.0.0 shipped).
  Code_McpConnection_Invalid = 'MCPCONN0001',
  Code_McpConnection_NotConnected = 'MCPCONN0002',
  Code_McpConnection_UserNotAuthorized = 'MCPCONN0004',
  Code_McpConnection_NeedsReauthorization = 'MCPCONN0005',
  Code_McpConnection_SkillOwnerRequired = 'MCPCONN0006',
  Code_McpConnection_NoSkillControlAccount = 'MCPCONN0007',
  // The install of the ISOPlanner GitHub App (API enum 434-439, PLAN-FBL-001).
  Code_GitHub_InstallStateInvalid = 'GITHUB0001',
  Code_GitHub_InstallationNotFound = 'GITHUB0002',
  Code_GitHub_InstallationNotOrganization = 'GITHUB0003',
  Code_GitHub_NotConfigured = 'GITHUB0004',
  Code_GitHub_AuthorizationFailed = 'GITHUB0005',
  Code_GitHub_NotInstalled = 'GITHUB0006',

  // Project. Mirrors ControllerException.cs. A string code is the wire contract, so new codes are
  // appended and existing codes keep their number.
  Code_Project_StaleVersion = 'PROJECT0001',
  Code_Project_NormRequired = 'PROJECT0004',
  Code_Project_TrialExpired = 'PROJECT0005',
  Code_Project_ModuleDisabled = 'PROJECT0006',
  Code_Project_StageTaskChecklistIncomplete = 'PROJECT0007',
  Code_Project_PackageOwnsProject = 'PROJECT0009',
  Code_Project_MilestoneEmpty = 'PROJECT0012',
  Code_Project_DeliverableCompleted = 'PROJECT0019',
  Code_Project_ReopenFailed = 'PROJECT0021',
  Code_Project_Archived = 'PROJECT0023',
  Code_Project_ItemNotInRoom = 'PROJECT0024',
  Code_Project_ItemInvalid = 'PROJECT0025',
  Code_Project_ItemArchived = 'PROJECT0026',
  Code_Project_FollowUpNotCreated = 'PROJECT0027',
  Code_Project_ApprovalUnavailable = 'PROJECT0028',
  Code_Project_AppointeeRequired = 'PROJECT0029',
  Code_Project_AppointeeNotLicensed = 'PROJECT0030',
  Code_Project_SystemRole = 'PROJECT0031',
  Code_Project_EditInLibrary = 'PROJECT0032',
  Code_Project_RoomNotConfirmable = 'PROJECT0033',
  // PROJECT0034 and PROJECT0036 refuse a package release; the API message names the task, room or key.
  Code_Project_JourneyTooDeep = 'PROJECT0034',
  Code_Project_JourneyOutOfDate = 'PROJECT0036',
  Code_Project_RoleSeveralHolders = 'PROJECT0038',
  Code_Project_InquiryLineNotOnList = 'PROJECT0040',
  Code_Project_InquiryImportTooLarge = 'PROJECT0041',
  Code_Project_InquiryLineNotOwn = 'PROJECT0042',
  Code_Project_RegisterIncomplete = 'PROJECT0044',
  Code_Project_RegisterApproved = 'PROJECT0045',
  Code_Project_RegisterMergeRefused = 'PROJECT0049',
  Code_Project_OutcomeAnswerInvalid = 'PROJECT0052',
  Code_Project_OutcomeDocumentNotChoosable = 'PROJECT0054',
  Code_Project_OutcomeReasonRequired = 'PROJECT0055',
  Code_Project_OutcomeNotOnList = 'PROJECT0056',
  Code_Project_MilestoneNotCurrent = 'PROJECT0060',
  Code_Project_MilestoneClosed = 'PROJECT0061',
  Code_Project_InquiryRoleNoHolder = 'PROJECT0063',
  Code_Project_InquiryHolderCannotTake = 'PROJECT0064',
  Code_Project_ExternalAuditQuoteOff = 'PROJECT0065',
  Code_Project_ExternalAuditQuoteFailed = 'PROJECT0066',
  Code_Project_OutcomeEvidenceNotAllowed = 'PROJECT0068',
  Code_Project_OutcomeEvidenceLinkInvalid = 'PROJECT0069',
  Code_Project_RegisterAwaitingInquiries = 'PROJECT0070',
  Code_Project_InquiryLineReasonRequired = 'PROJECT0075',
  Code_Project_OutcomeBoundElsewhere = 'PROJECT0076',
  Code_Project_ApproveNotDirectie = 'PROJECT0077',
  Code_Project_InquiryLineAddedByOther = 'PROJECT0130',
  Code_Project_InquiryLineChanged = 'PROJECT0131',
  // The inquiry lifecycle: complete of an inquiry that is not open.
  Code_Project_InquiryNotOpen = 'PROJECT0111',

  // Document providers. Mirrors ControllerException.cs.
  Code_DocumentProvider_NotSupported = 'DOCPROV0001',
  Code_DocumentProvider_ConnectionNotFound = 'DOCPROV0002',
  Code_DocumentProvider_ConnectionDisabled = 'DOCPROV0003',
  Code_DocumentProvider_AuthFailed = 'DOCPROV0004',
  Code_DocumentProvider_ItemNotFound = 'DOCPROV0005',
  Code_DocumentProvider_RemoteError = 'DOCPROV0006',
  Code_DocumentProvider_ConnectionInUse = 'DOCPROV0007',
  Code_DocumentProvider_HostNotAllowed = 'DOCPROV0008',
  Code_DocumentProvider_RateLimited = 'DOCPROV0009',
  Code_DocumentProvider_CategoryNotBound = 'DOCPROV0010',
  Code_DocumentProvider_InvalidRequest = 'DOCPROV0011',

  // Identity providers. Mirrors ControllerException.cs. A refusal of the login itself arrives as a
  // 401 whose body carries the code (see getIdentityProviderErrorCode).
  Code_Identity_ProviderNotSupported = 'IDP0001',
  Code_Identity_BusinessAccountRequired = 'IDP0002',
  Code_Identity_MicrosoftIdentityRequired = 'IDP0003',
  Code_Identity_DirectoryMismatch = 'IDP0004',
  Code_Identity_EmailNotVerified = 'IDP0005',
  Code_Identity_DirectoryConnectionRequired = 'IDP0006',
  Code_Identity_DirectoryConnectionFailed = 'IDP0007',
  Code_Identity_AccountNotClaimable = 'IDP0008',
  Code_Identity_DirectoryConsentRequired = 'IDP0009',
  // A user-delegated connection the signed-in user has not connected their own account to yet (or the provider refused it);
  // the message carries the connection name. Rendered as the Connect card, not as an error.
  Code_DocumentProvider_UserGrantRequired = 'DOCPROV0012',
  // A domain-delegated connection whose organization has no verified Google Workspace delegation, or Google withdrew it
  Code_DocumentProvider_WorkspaceNotAuthorized = 'DOCPROV0013',
  // The file is larger than the Office Online viewer takes; the message carries the limit in MB
  Code_DocumentProvider_PreviewTooLarge = 'DOCPROV0014',

  // Announcements (Tenant Admin authoring). Mirrors ControllerException.cs. The API message is plain
  // English and names the refused value; the editor shows the text of the code instead.
  Code_Announcement_InvalidRequest = 'ANNOUNCEMENT0001',
  Code_Announcement_StateChangeNotAllowed = 'ANNOUNCEMENT0002',
  Code_Announcement_TransitionNotAllowed = 'ANNOUNCEMENT0003',
  Code_Announcement_TextRequired = 'ANNOUNCEMENT0004',
  Code_Announcement_TextTooLong = 'ANNOUNCEMENT0005',
  Code_Announcement_TargetRequired = 'ANNOUNCEMENT0006',
  Code_Announcement_TargetUnknown = 'ANNOUNCEMENT0007',
  Code_Announcement_PublishOnRequired = 'ANNOUNCEMENT0008',
  Code_Announcement_ExpiryNotInFuture = 'ANNOUNCEMENT0009',
  Code_Announcement_ExpiryBeforePublish = 'ANNOUNCEMENT0010',
  Code_Announcement_TargetTranslationMissing = 'ANNOUNCEMENT0011',
  Code_Announcement_TranslationNotReviewed = 'ANNOUNCEMENT0012',
  Code_Announcement_ExternalImage = 'ANNOUNCEMENT0013',
  Code_Announcement_OtherMedia = 'ANNOUNCEMENT0014',
  Code_Announcement_ImageUnknown = 'ANNOUNCEMENT0015',
  Code_Announcement_ImageInUse = 'ANNOUNCEMENT0016',
  Code_Announcement_ImageMissing = 'ANNOUNCEMENT0017',
  Code_Announcement_ImageType = 'ANNOUNCEMENT0018',
  Code_Announcement_ImageTooLarge = 'ANNOUNCEMENT0019',
  Code_Announcement_ImageTooManyPixels = 'ANNOUNCEMENT0020',
  Code_Announcement_ImageTooManyFrames = 'ANNOUNCEMENT0021',

  // Document output locations (Admin, Settings, Reports). Mirrors ControllerException.cs: the refusals of
  // PUT settings/outputlocations/{purpose}.
  Code_OutputLocation_NotADocumentLibrary = 'OUTPUTLOC0001',
  Code_OutputLocation_ProviderNotAllowed = 'OUTPUTLOC0002',
  Code_OutputLocation_TemplateNotInLocation = 'OUTPUTLOC0003',
  Code_OutputLocation_TemplateNotAllowed = 'OUTPUTLOC0004',
  // The evidence output bindings: a folder name format the catalogue refuses (the problems in the message), a
  // binding on a task that is no template, an evidence folder asked for a task without a bound category
  Code_OutputLocation_InvalidFormat = 'OUTPUTLOC0005',
  Code_OutputLocation_NotATemplate = 'OUTPUTLOC0006',
  Code_OutputLocation_NotBound = 'OUTPUTLOC0007',
  // A per-template setting asked of a purpose that takes none, such as the KPI attachments
  Code_OutputLocation_NoTemplateSettings = 'OUTPUTLOC0008',
  // the start folder of the output location no longer exists; the web downloads the file instead (PLAN-069)
  Code_OutputLocation_StartFolderNotFound = 'OUTPUTLOC0009',
}

export default class ControllerException {
  code: string;

  message?: string | undefined;

  constructor() {
    this.code = '';
  }

  // `message` carries the exception's Message field from the API, used for codes
  // whose i18n template needs dynamic data. Backwards-compatible for existing
  // 2-arg call sites: when message is undefined, templates with placeholders
  // render with the placeholder left as-is (same as before).
  static getMessage(code: ControllerExceptionCodes, t: TFunction<string[]>, message?: string): string {
    switch (code) {
      case ControllerExceptionCodes.Code_General_NotAuthorized:
        return t('exceptions:General.NoAuth');
      case ControllerExceptionCodes.Code_General_NotFound:
        return t('exceptions:General.NotFound');
      case ControllerExceptionCodes.Code_Task_CanOnlyMoveToArchivedFromCompletedAndRejected:
        return t('exceptions:Task.CanOnlyMoveToArchivedFromCompleted');
      case ControllerExceptionCodes.Code_Risk_DuplicateCode:
        return t('exceptions:Risk.DuplicateCode');
      case ControllerExceptionCodes.Code_Asset_DuplicateCode:
        return t('exceptions:Asset.DuplicateCode');
      case ControllerExceptionCodes.Code_Auth_TenantAlreadyRegistered:
        return t('exceptions:Auth.TenantAlreadyRegistered');
      case ControllerExceptionCodes.Code_Auth_TooManyLicensesAssigned:
        return t('exceptions:Auth.TooManyLicensesAssigned');
      case ControllerExceptionCodes.Code_Auth_CannotRemoveLastAdmin:
        return t('exceptions:Auth.CannotRemoveLastAdmin');
      case ControllerExceptionCodes.Code_Auth_CannotUnlicenseLastUser:
        return t('exceptions:Auth.CannotUnlicenseLastUser');
      case ControllerExceptionCodes.Code_Auth_CannotSearchNoSites:
        return t('exceptions:Auth.CannotSearchNoSites');
      case ControllerExceptionCodes.Code_Auth_NewPermissionsRequired:
        return t('exceptions:Auth.NewPermissionsRequired');
      case ControllerExceptionCodes.Code_Auth_ConsultantNotAtPartner:
        return t('exceptions:Auth.ConsultantNotAtPartner', { email: message ?? '' });
      case ControllerExceptionCodes.Code_Auth_ConsultantAtMultiplePartners:
        return t('exceptions:Auth.ConsultantAtMultiplePartners', { email: message ?? '' });
      case ControllerExceptionCodes.Code_Auth_PartnerAlreadyAssigned:
        return t('exceptions:Auth.PartnerAlreadyAssigned', { partner: message ?? '' });
      case ControllerExceptionCodes.Code_Auth_PartnerCannotAppointConsultant:
        return t('exceptions:Auth.PartnerCannotAppointConsultant');
      case ControllerExceptionCodes.Code_Auth_CannotAssignRoleToYourself:
        return t('exceptions:Auth.CannotAssignRoleToYourself');
      case ControllerExceptionCodes.Code_Group_DoesNotExist:
        return t('exceptions:Group.NotFound');
      case ControllerExceptionCodes.Code_ProcessingActivity_DuplicateCode:
        return t('exceptions:ProcessingActivity.DuplicateCode');
      case ControllerExceptionCodes.Code_Graph_FileLocked:
        return t('sharepoint:PublicationStatus.Locked');
      case ControllerExceptionCodes.Code_Planner_InvalidConfig:
        return t('adminCompany:Tabs.Integration.Planner.Errors.InvalidConfig');
      case ControllerExceptionCodes.Code_Task_CannotDeleteTemplateOfIntegration:
        return t('exceptions:Task.CannotDeleteTemplateOfIntegration');
      case ControllerExceptionCodes.Code_Task_CannotDeleteEvidenceTask:
        return t('exceptions:Task.CannotDeleteEvidenceTask');
      case ControllerExceptionCodes.Code_Task_FormIncomplete:
        // API sends the names of the refused form fields in Message.
        return t('exceptions:Task.FormIncomplete', { fields: message ?? '' });
      case ControllerExceptionCodes.Code_Task_FormFamilyHasProducers:
        return t('exceptions:Task.FormFamilyHasProducers');
      case ControllerExceptionCodes.Code_Task_ReservedExternalId:
        return t('exceptions:Task.ReservedExternalId');
      case ControllerExceptionCodes.Code_Task_CalendarUnavailable:
        // API saved the task; Microsoft 365 did not answer the Outlook calendar call. The Graph detail in
        // Message is for the request log, not for the user.
        return t('exceptions:Task.CalendarUnavailable');
      case ControllerExceptionCodes.Code_Task_RecurringNormalTask:
        return t('exceptions:Task.RecurringNormalTask');
      case ControllerExceptionCodes.Code_Task_NotStartedYet:
        return t('exceptions:Task.NotStartedYet');
      case ControllerExceptionCodes.Code_Task_TypeConversionNotAllowed:
        return t('exceptions:Task.TypeConversionNotAllowed');
      case ControllerExceptionCodes.Code_KPI_UsedInForm:
        return t('exceptions:KPI.UsedInForm');
      case ControllerExceptionCodes.Code_Package_AlreadyInstalling:
        return t('exceptions:Package.AlreadyInstalling');
      case ControllerExceptionCodes.Code_Package_RecurringNormalTask:
        return t('exceptions:Package.RecurringNormalTask');
      case ControllerExceptionCodes.Code_Onboarding_AlreadyRunning:
        return t('exceptions:Onboarding.AlreadyRunning');
      case ControllerExceptionCodes.Code_AIModel_Invalid:
        //the API message names the refused value; it is written for the administrator
        return message ?? t('exceptions:AIModel.Invalid');
      case ControllerExceptionCodes.Code_AIModel_NotReady:
        return t('exceptions:AIModel.NotReady');
      case ControllerExceptionCodes.Code_AIModel_InternetResearchOff:
        return t('exceptions:AIModel.InternetResearchOff');
      case ControllerExceptionCodes.Code_Credit_NoCreditsAvailable:
        return t('exceptions:Credit.UsedUp');
      case ControllerExceptionCodes.Code_McpConnection_Invalid:
        //the API message says what was refused; it is written for the administrator
        return message ?? t('exceptions:McpConnection.Invalid');
      case ControllerExceptionCodes.Code_McpConnection_NotConnected:
        return t('exceptions:McpConnection.NotConnected');
      case ControllerExceptionCodes.Code_McpConnection_UserNotAuthorized:
        return t('exceptions:McpConnection.UserNotAuthorized');
      case ControllerExceptionCodes.Code_McpConnection_NeedsReauthorization:
        return t('exceptions:McpConnection.NeedsReauthorization');
      case ControllerExceptionCodes.Code_McpConnection_SkillOwnerRequired:
        return t('exceptions:McpConnection.SkillOwnerRequired');
      case ControllerExceptionCodes.Code_McpConnection_NoSkillControlAccount:
        return t('exceptions:McpConnection.NoSkillControlAccount');
      case ControllerExceptionCodes.Code_GitHub_InstallStateInvalid:
        return t('exceptions:GitHub.InstallStateInvalid');
      case ControllerExceptionCodes.Code_GitHub_InstallationNotFound:
        return t('exceptions:GitHub.InstallationNotFound');
      case ControllerExceptionCodes.Code_GitHub_InstallationNotOrganization:
        return t('exceptions:GitHub.InstallationNotOrganization');
      case ControllerExceptionCodes.Code_GitHub_NotConfigured:
        return t('exceptions:GitHub.NotConfigured');
      case ControllerExceptionCodes.Code_GitHub_AuthorizationFailed:
        // the API names GitHub's reason (its error code) in the message
        return t('exceptions:GitHub.AuthorizationFailed', { detail: message ?? '' });
      case ControllerExceptionCodes.Code_GitHub_NotInstalled:
        return t('exceptions:GitHub.NotInstalled');
      case ControllerExceptionCodes.Code_Task_IntegrationTemplateMustHaveTagControlFinding:
        return t('exceptions:Task.IntegrationTemplateMustHaveTagControlFinding');
      case ControllerExceptionCodes.Code_Tag_MustHaveTagsForEachSystemType:
        return t('exceptions:Tag.MustHaveTagsForEachSystemType');
      case ControllerExceptionCodes.Code_Task_StartDateBeforeLastCompletedInstance: {
        // API sends the lower-bound date in Message as an ISO-8601 ("o") string.
        // Format in the user's locale via Intl.DateTimeFormat (honours the browser
        // locale; no date library dependency added).
        let minDate = message ?? '';
        if (message) {
          const parsed = new Date(message);
          if (!Number.isNaN(parsed.getTime())) {
            minDate = new Intl.DateTimeFormat(undefined, { dateStyle: 'long' }).format(parsed);
          }
        }

        return t('exceptions:Task.StartDateBeforeLastCompletedInstance', { minDate });
      }
      case ControllerExceptionCodes.Code_Task_EndDateAfterNextInstance: {
        // API sends the upper-bound date in Message as an ISO-8601 ("o") string.
        // Format in the user's locale via Intl.DateTimeFormat (honours the browser
        // locale; no date library dependency added).
        let maxDate = message ?? '';
        if (message) {
          const parsed = new Date(message);
          if (!Number.isNaN(parsed.getTime())) {
            maxDate = new Intl.DateTimeFormat(undefined, { dateStyle: 'long' }).format(parsed);
          }
        }

        return t('exceptions:Task.EndDateAfterNextInstance', { maxDate });
      }
      case ControllerExceptionCodes.Code_Integration_MissingGraphPermission:
        // API sends the missing Microsoft Graph permission name (e.g. "AuditLog.Read.All")
        // in Message. The i18n template names it so the customer admin knows exactly
        // which permission to grant, instead of a generic "Error during test run" toast.
        return t('exceptions:Integration.MissingGraphPermission', { permission: message ?? '' });
      case ControllerExceptionCodes.Code_Integration_NoGraphPermissions:
        // The integration's app has no Graph permissions consented at all -- different
        // remediation than INTEGRATION0001 (configure the app, not just grant one).
        return t('exceptions:Integration.NoGraphPermissions');
      case ControllerExceptionCodes.Code_Integration_AuthFailureGeneric:
        // Any other Graph auth failure (HTTP 403, conditional access, expired token, ...).
        // Surface the classifier's message verbatim so the user has at least one actionable
        // detail to share with their admin/support.
        return t('exceptions:Integration.AuthFailureGeneric', { detail: message ?? '' });
      case ControllerExceptionCodes.Code_Integration_OAuthNotConfigured:
        // The environment has no client id or secret for the app: nothing the user can fix.
        return t('exceptions:Integration.OAuthNotConfigured');
      case ControllerExceptionCodes.Code_Report_SharePointReportsDisabled:
        return t('exceptions:Report.SharePointReportsDisabled');
      case ControllerExceptionCodes.Code_Report_SharePointPermissionsMissing:
        return t('exceptions:Report.SharePointPermissionsMissing');
      case ControllerExceptionCodes.Code_Report_ExportSourceLegacyWord:
        return t('exceptions:Report.ExportSourceLegacyWord');
      case ControllerExceptionCodes.Code_Report_ExportSourceProtected:
        return t('exceptions:Report.ExportSourceProtected');
      case ControllerExceptionCodes.Code_Report_ExportSourceUnreadable:
        return t('exceptions:Report.ExportSourceUnreadable');
      case ControllerExceptionCodes.Code_Report_PdfNotAvailable:
        return t('exceptions:Report.PdfNotAvailable');
      case ControllerExceptionCodes.Code_TaskView_DuplicateName:
        return t('exceptions:TaskView.DuplicateName');
      case ControllerExceptionCodes.Code_Billing_SubscriptionRequired:
        return t('exceptions:Billing.SubscriptionRequired');
      case ControllerExceptionCodes.Code_Library_TargetNotFound:
        return t('exceptions:Library.TargetNotFound');
      case ControllerExceptionCodes.Code_Library_NoWritePermission:
        return t('exceptions:Library.NoWritePermission');
      case ControllerExceptionCodes.Code_Library_TargetLocked:
        return t('exceptions:Library.TargetLocked');
      case ControllerExceptionCodes.Code_DocumentProvider_NotSupported:
        return t('exceptions:DocumentProvider.NotSupported');
      case ControllerExceptionCodes.Code_DocumentProvider_ConnectionNotFound:
        return t('exceptions:DocumentProvider.ConnectionNotFound');
      case ControllerExceptionCodes.Code_DocumentProvider_ConnectionDisabled:
        return t('exceptions:DocumentProvider.ConnectionDisabled');
      case ControllerExceptionCodes.Code_DocumentProvider_AuthFailed:
        return t('exceptions:DocumentProvider.AuthFailed');
      case ControllerExceptionCodes.Code_DocumentProvider_ItemNotFound:
        return t('exceptions:DocumentProvider.ItemNotFound');
      case ControllerExceptionCodes.Code_DocumentProvider_RemoteError:
        return t('exceptions:DocumentProvider.RemoteError');
      case ControllerExceptionCodes.Code_DocumentProvider_ConnectionInUse:
        // API sends the names of the categories (up to five) in Message
        return t('exceptions:DocumentProvider.ConnectionInUse', { categories: message ?? '' });
      case ControllerExceptionCodes.Code_DocumentProvider_HostNotAllowed:
        return t('exceptions:DocumentProvider.HostNotAllowed');
      case ControllerExceptionCodes.Code_DocumentProvider_RateLimited:
        return t('exceptions:DocumentProvider.RateLimited');
      case ControllerExceptionCodes.Code_DocumentProvider_CategoryNotBound:
        // API sends the category name in Message so the text can say which one to fix
        return t('exceptions:DocumentProvider.CategoryNotBound', { category: message ?? '' });
      case ControllerExceptionCodes.Code_DocumentProvider_InvalidRequest:
        // The server's sentence (a size limit, a missing name) is the only actionable detail;
        // frame it in the user's language rather than dropping it
        return t('exceptions:DocumentProvider.InvalidRequest', { detail: message ?? '' });
      case ControllerExceptionCodes.Code_Library_DuplicateExternalId:
        return t('exceptions:Library.DuplicateExternalId');
      case ControllerExceptionCodes.Code_Library_ConnectionNotInherited:
        return t('exceptions:Library.ConnectionNotInherited');
      case ControllerExceptionCodes.Code_Library_UploadTypeNotAllowed:
        // API sends the file's type in Message
        return t('exceptions:Library.UploadTypeNotAllowed', { type: message ?? '' });
      case ControllerExceptionCodes.Code_Library_UploadTooLarge:
        // API sends the cap in MB in Message
        return t('exceptions:Library.UploadTooLarge', { size: message ?? '' });
      case ControllerExceptionCodes.Code_Asset_DuplicateExternalId:
        return t('exceptions:Asset.DuplicateExternalId');
      case ControllerExceptionCodes.Code_Asset_TooManyTemplates:
        return t('exceptions:Asset.TooManyTemplates');
      case ControllerExceptionCodes.Code_Asset_DuplicateName:
        return t('exceptions:Asset.DuplicateName');
      case ControllerExceptionCodes.Code_Asset_NotASupplier:
        return t('exceptions:Asset.NotASupplier');
      case ControllerExceptionCodes.Code_Asset_CompliancePlanExpired:
        return t('exceptions:Asset.CompliancePlanExpired');
      case ControllerExceptionCodes.Code_Asset_ComplianceNoReport:
        return t('exceptions:Asset.ComplianceNoReport');
      case ControllerExceptionCodes.Code_Task_DuplicateExternalId:
        return t('exceptions:Task.DuplicateExternalId');
      case ControllerExceptionCodes.Code_Process_DuplicateExternalId:
        return t('exceptions:Process.DuplicateExternalId');
      case ControllerExceptionCodes.Code_Objective_DuplicateExternalId:
        return t('exceptions:Objective.DuplicateExternalId');
      case ControllerExceptionCodes.Code_Risk_DuplicateExternalId:
        return t('exceptions:Risk.DuplicateExternalId');
      case ControllerExceptionCodes.Code_OrgUnit_BindNotAllowed:
        return t('exceptions:OrgUnit.BindNotAllowed');
      case ControllerExceptionCodes.Code_OrgUnit_BindContainerNotAllowed:
        return t('exceptions:OrgUnit.BindContainerNotAllowed');
      case ControllerExceptionCodes.Code_OrgUnit_BindDirectoryInUse:
        return t('exceptions:OrgUnit.BindDirectoryInUse');
      case ControllerExceptionCodes.Code_OrgUnit_BindDirectoryNotFound:
        return t('exceptions:OrgUnit.BindDirectoryNotFound');
      case ControllerExceptionCodes.Code_Task_EndDateAfterDeadline:
        return t('exceptions:Task.EndDateAfterDeadline');
      case ControllerExceptionCodes.Code_Standard_MaxStandardsReached:
        return t('exceptions:Standard.MaxStandardsReached');
      case ControllerExceptionCodes.Code_Backup_AlreadyInProgress:
        return t('exceptions:Backup.AlreadyInProgress');
      case ControllerExceptionCodes.Code_Backup_ManualQuotaReached:
        // API sends the configured maximum in Message so the text can name it
        return t('exceptions:Backup.ManualQuotaReached', { max: message ?? '' });
      case ControllerExceptionCodes.Code_Backup_NotReadyToRestore:
        return t('exceptions:Backup.NotReadyToRestore');
      case ControllerExceptionCodes.Code_Backup_NotIncludedInSubscription:
        return t('exceptions:Backup.NotIncludedInSubscription');
      case ControllerExceptionCodes.Code_Backup_DeleteTargetNotAllowed:
        return t('exceptions:Backup.DeleteTargetNotAllowed');
      case ControllerExceptionCodes.Code_Backup_PointInTimeUnavailable:
        return t('exceptions:Backup.PointInTimeUnavailable');
      case ControllerExceptionCodes.Code_Backup_HistoryUnavailable:
        return t('exceptions:Backup.HistoryUnavailable');
      case ControllerExceptionCodes.Code_Backup_TenantHeldByFailedRestore:
        return t('exceptions:Backup.TenantHeldByFailedRestore');
      case ControllerExceptionCodes.Code_InternalAudit_TeamIncomplete:
        return t('exceptions:Audit.TeamIncomplete');
      case ControllerExceptionCodes.Code_InternalAudit_ScopeEmpty:
        return t('exceptions:Audit.ScopeEmpty');
      case ControllerExceptionCodes.Code_InternalAudit_MeetingOrganizerMismatch:
        // API sends the organizer's display name in Message
        return t('exceptions:Audit.MeetingOrganizerMismatch', { name: message ?? '' });
      case ControllerExceptionCodes.Code_InternalAudit_OpenExecutionTasks:
        return t('exceptions:Audit.OpenExecutionTasks');
      case ControllerExceptionCodes.Code_InternalAudit_UnassignedScopeItems:
        return t('exceptions:Audit.UnassignedScopeItems');
      case ControllerExceptionCodes.Code_InternalAudit_UnassessedScopeItems:
        return t('exceptions:Audit.UnassessedScopeItems');
      case ControllerExceptionCodes.Code_InternalAudit_ResultsFrozen:
        return t('exceptions:Audit.ResultsFrozen');
      case ControllerExceptionCodes.Code_InternalAudit_AssigneeNotAuditee:
        return t('exceptions:Audit.AssigneeNotAuditee');
      case ControllerExceptionCodes.Code_InternalAudit_Published:
        return t('exceptions:Audit.Published');
      case ControllerExceptionCodes.Code_InternalAudit_ResetNotAllowed:
        return t('exceptions:Audit.ResetNotAllowed');
      case ControllerExceptionCodes.Code_InternalAudit_UnassignedOpenTasks:
        return t('exceptions:Audit.UnassignedOpenTasks');
      case ControllerExceptionCodes.Code_InternalAudit_StartDateRequired:
        return t('exceptions:Audit.StartDateRequired');
      case ControllerExceptionCodes.Code_InternalAudit_PlanOutsidePeriod:
        return t('exceptions:Audit.PlanOutsidePeriod');
      case ControllerExceptionCodes.Code_InternalAudit_UnknownProcedure:
        return t('exceptions:Audit.UnknownProcedure');
      case ControllerExceptionCodes.Code_InternalAudit_UnknownState:
        return t('exceptions:Audit.UnknownState');
      case ControllerExceptionCodes.Code_InternalAudit_StatusStepSkipped:
        return t('exceptions:Audit.StatusStepSkipped');
      case ControllerExceptionCodes.Code_InternalAudit_ReportingIntegrationOff:
        return t('exceptions:Audit.ReportingIntegrationOff');
      case ControllerExceptionCodes.Code_InternalAudit_FindingsMissing:
        return t('exceptions:Audit.FindingsMissing');
      case ControllerExceptionCodes.Code_InternalAudit_ReportMissing:
        return t('exceptions:Audit.ReportMissing');
      case ControllerExceptionCodes.Code_InternalAudit_ReportOutdated:
        return t('exceptions:Audit.ReportOutdated');
      case ControllerExceptionCodes.Code_InternalAudit_InvalidScopeOrder:
        return t('exceptions:Audit.InvalidScopeOrder');
      case ControllerExceptionCodes.Code_InternalAudit_TeamPermissions:
        return t('exceptions:Audit.TeamPermissions');
      case ControllerExceptionCodes.Code_InternalAudit_ProcedureContentInvalid:
        return t('exceptions:Audit.ProcedureContentInvalid');
      case ControllerExceptionCodes.Code_InternalAudit_ProcedureFormLocked:
        return t('exceptions:Audit.ProcedureFormLocked');
      case ControllerExceptionCodes.Code_InternalAudit_NothingAudited:
        return t('exceptions:Audit.NothingAudited');
      case ControllerExceptionCodes.Code_InternalAudit_StandardsRequired:
        return t('exceptions:Audit.StandardsRequired');
      case ControllerExceptionCodes.Code_InternalAudit_CriteriaChanged:
        return t('exceptions:Audit.CriteriaChanged');
      case ControllerExceptionCodes.Code_InternalAudit_ImprovementAlreadyApplied:
        return t('exceptions:Audit.ImprovementAlreadyApplied');
      case ControllerExceptionCodes.Code_InternalAudit_CriterionAnswerRoleInvalid:
        return t('exceptions:Audit.CriterionAnswerRoleInvalid');
      case ControllerExceptionCodes.Code_InternalAudit_ReportFolderExists:
        return t('exceptions:Audit.ReportFolderExists');
      case ControllerExceptionCodes.Code_InternalAudit_ReportLocationMissing:
        return t('exceptions:Audit.ReportLocationMissing');
      case ControllerExceptionCodes.Code_InternalAudit_ReportLocationNoWriteAccess:
        return t('exceptions:Audit.ReportLocationNoWriteAccess');
      case ControllerExceptionCodes.Code_InternalAudit_NoCriteriaSet:
        return t('exceptions:Audit.NoCriteriaSet');
      case ControllerExceptionCodes.Code_Project_StaleVersion:
        return t('exceptions:Project.StaleVersion');
      case ControllerExceptionCodes.Code_Project_NormRequired:
        return t('exceptions:Project.NormRequired');
      case ControllerExceptionCodes.Code_Project_TrialExpired:
        return t('exceptions:Project.TrialExpired');
      case ControllerExceptionCodes.Code_Project_ModuleDisabled:
        return t('exceptions:Project.ModuleDisabled');
      case ControllerExceptionCodes.Code_Project_StageTaskChecklistIncomplete:
        return t('exceptions:Project.StageTaskChecklistIncomplete');
      case ControllerExceptionCodes.Code_Project_PackageOwnsProject:
        return t('exceptions:Project.PackageOwnsProject');
      case ControllerExceptionCodes.Code_Project_MilestoneEmpty:
        return t('exceptions:Project.MilestoneEmpty');
      case ControllerExceptionCodes.Code_Project_DeliverableCompleted:
        return t('exceptions:Project.DeliverableCompleted');
      case ControllerExceptionCodes.Code_Project_ReopenFailed:
        return t('exceptions:Project.ReopenFailed');
      case ControllerExceptionCodes.Code_Project_Archived:
        return t('exceptions:Project.Archived');
      case ControllerExceptionCodes.Code_Project_ItemNotInRoom:
        return t('exceptions:Project.ItemNotInRoom');
      case ControllerExceptionCodes.Code_Project_ItemInvalid:
        return t('exceptions:Project.ItemInvalid');
      case ControllerExceptionCodes.Code_Project_ItemArchived:
        return t('exceptions:Project.ItemArchived');
      case ControllerExceptionCodes.Code_Project_FollowUpNotCreated:
        return t('exceptions:Project.FollowUpNotCreated');
      case ControllerExceptionCodes.Code_Project_ApprovalUnavailable:
        return t('exceptions:Project.ApprovalUnavailable');
      case ControllerExceptionCodes.Code_Project_AppointeeRequired:
        return t('exceptions:Project.AppointeeRequired');
      case ControllerExceptionCodes.Code_Project_AppointeeNotLicensed:
        return t('exceptions:Project.AppointeeNotLicensed');
      case ControllerExceptionCodes.Code_Project_SystemRole:
        return t('exceptions:Project.SystemRole');
      case ControllerExceptionCodes.Code_Project_EditInLibrary:
        return t('exceptions:Project.EditInLibrary');
      case ControllerExceptionCodes.Code_Project_RoomNotConfirmable:
        return t('exceptions:Project.RoomNotConfirmable');
      case ControllerExceptionCodes.Code_Project_JourneyTooDeep:
        return t('exceptions:Project.JourneyTooDeep', { detail: message ?? '' });
      case ControllerExceptionCodes.Code_Project_JourneyOutOfDate:
        return t('exceptions:Project.JourneyOutOfDate', { detail: message ?? '' });
      case ControllerExceptionCodes.Code_Project_RoleSeveralHolders:
        return t('exceptions:Project.RoleSeveralHolders');
      case ControllerExceptionCodes.Code_Project_InquiryLineNotOnList:
        return t('exceptions:Project.InquiryLineNotOnList');
      case ControllerExceptionCodes.Code_Project_InquiryImportTooLarge:
        return t('exceptions:Project.InquiryImportTooLarge');
      case ControllerExceptionCodes.Code_Project_InquiryLineNotOwn:
        return t('exceptions:Project.InquiryLineNotOwn');
      case ControllerExceptionCodes.Code_Project_RegisterIncomplete:
        return t('exceptions:Project.RegisterIncomplete');
      case ControllerExceptionCodes.Code_Project_RegisterApproved:
        return t('exceptions:Project.RegisterApproved');
      case ControllerExceptionCodes.Code_Project_RegisterMergeRefused:
        return t('exceptions:Project.RegisterMergeRefused');
      case ControllerExceptionCodes.Code_Project_OutcomeAnswerInvalid:
        return t('exceptions:Project.OutcomeAnswerInvalid');
      case ControllerExceptionCodes.Code_Project_OutcomeDocumentNotChoosable:
        return t('exceptions:Project.OutcomeDocumentNotChoosable');
      case ControllerExceptionCodes.Code_Project_OutcomeReasonRequired:
        return t('exceptions:Project.OutcomeReasonRequired');
      case ControllerExceptionCodes.Code_Project_OutcomeNotOnList:
        return t('exceptions:Project.OutcomeNotOnList');
      case ControllerExceptionCodes.Code_Project_MilestoneNotCurrent:
        return t('exceptions:Project.MilestoneNotCurrent');
      case ControllerExceptionCodes.Code_Project_MilestoneClosed:
        return t('exceptions:Project.MilestoneClosed');
      case ControllerExceptionCodes.Code_Project_InquiryRoleNoHolder:
        return t('exceptions:Project.InquiryRoleNoHolder');
      case ControllerExceptionCodes.Code_Project_InquiryHolderCannotTake:
        return t('exceptions:Project.InquiryHolderCannotTake');
      case ControllerExceptionCodes.Code_Project_ExternalAuditQuoteOff:
        return t('exceptions:Project.ExternalAuditQuoteOff');
      case ControllerExceptionCodes.Code_Project_ExternalAuditQuoteFailed:
        return t('exceptions:Project.ExternalAuditQuoteFailed');
      case ControllerExceptionCodes.Code_Project_OutcomeEvidenceNotAllowed:
        return t('exceptions:Project.OutcomeEvidenceNotAllowed');
      case ControllerExceptionCodes.Code_Project_OutcomeEvidenceLinkInvalid:
        return t('exceptions:Project.OutcomeEvidenceLinkInvalid');
      case ControllerExceptionCodes.Code_Project_RegisterAwaitingInquiries:
        return t('exceptions:Project.RegisterAwaitingInquiries');
      case ControllerExceptionCodes.Code_Project_InquiryLineReasonRequired:
        return t('exceptions:Project.InquiryLineReasonRequired');
      case ControllerExceptionCodes.Code_Project_OutcomeBoundElsewhere:
        return t('exceptions:Project.OutcomeBoundElsewhere');
      case ControllerExceptionCodes.Code_Project_ApproveNotDirectie:
        return t('exceptions:Project.ApproveNotDirectie');
      case ControllerExceptionCodes.Code_Project_InquiryLineAddedByOther:
        return t('exceptions:Project.InquiryLineAddedByOther');
      case ControllerExceptionCodes.Code_Project_InquiryLineChanged:
        return t('exceptions:Project.InquiryLineChanged');
      case ControllerExceptionCodes.Code_Project_InquiryNotOpen:
        return t('exceptions:Project.InquiryNotOpen');
      case ControllerExceptionCodes.Code_Identity_ProviderNotSupported:
        return t('exceptions:Identity.ProviderNotSupported');
      case ControllerExceptionCodes.Code_Identity_BusinessAccountRequired:
        return t('exceptions:Identity.BusinessAccountRequired');
      case ControllerExceptionCodes.Code_Identity_MicrosoftIdentityRequired:
        return t('exceptions:Identity.MicrosoftIdentityRequired');
      case ControllerExceptionCodes.Code_Identity_DirectoryMismatch:
        return t('exceptions:Identity.DirectoryMismatch');
      case ControllerExceptionCodes.Code_Identity_EmailNotVerified:
        return t('exceptions:Identity.EmailNotVerified');
      case ControllerExceptionCodes.Code_Identity_DirectoryConnectionRequired:
        return t('exceptions:Identity.DirectoryConnectionRequired');
      case ControllerExceptionCodes.Code_Identity_DirectoryConnectionFailed:
        // The server's sentence (an invalid domain, Google's refusal) is the actionable part
        return t('exceptions:Identity.DirectoryConnectionFailed', { detail: message ?? '' });
      case ControllerExceptionCodes.Code_Identity_AccountNotClaimable:
        return t('exceptions:Identity.AccountNotClaimable', { detail: message ?? '' });
      case ControllerExceptionCodes.Code_Identity_DirectoryConsentRequired:
        return t('exceptions:Identity.DirectoryConsentRequired');
      case ControllerExceptionCodes.Code_DocumentProvider_UserGrantRequired:
        // API sends the connection name in Message so the sentence can say which account to connect
        return t('exceptions:DocumentProvider.UserGrantRequired', { connection: message ?? '' });
      case ControllerExceptionCodes.Code_DocumentProvider_WorkspaceNotAuthorized:
        return t('exceptions:DocumentProvider.WorkspaceNotAuthorized');
      case ControllerExceptionCodes.Code_DocumentProvider_PreviewTooLarge:
        // API sends the viewer's limit in MB in Message so the sentence can name it
        return t('exceptions:DocumentProvider.PreviewTooLarge', { limit: message ?? '' });
      case ControllerExceptionCodes.Code_Announcement_InvalidRequest:
        return t('exceptions:Announcement.InvalidRequest');
      case ControllerExceptionCodes.Code_Announcement_StateChangeNotAllowed:
        return t('exceptions:Announcement.StateChangeNotAllowed');
      case ControllerExceptionCodes.Code_Announcement_TransitionNotAllowed:
        return t('exceptions:Announcement.TransitionNotAllowed');
      case ControllerExceptionCodes.Code_Announcement_TextRequired:
        return t('exceptions:Announcement.TextRequired');
      case ControllerExceptionCodes.Code_Announcement_TextTooLong:
        return t('exceptions:Announcement.TextTooLong');
      case ControllerExceptionCodes.Code_Announcement_TargetRequired:
        return t('exceptions:Announcement.TargetRequired');
      case ControllerExceptionCodes.Code_Announcement_TargetUnknown:
        return t('exceptions:Announcement.TargetUnknown');
      case ControllerExceptionCodes.Code_Announcement_PublishOnRequired:
        return t('exceptions:Announcement.PublishOnRequired');
      case ControllerExceptionCodes.Code_Announcement_ExpiryNotInFuture:
        return t('exceptions:Announcement.ExpiryNotInFuture');
      case ControllerExceptionCodes.Code_Announcement_ExpiryBeforePublish:
        return t('exceptions:Announcement.ExpiryBeforePublish');
      case ControllerExceptionCodes.Code_Announcement_TargetTranslationMissing:
        return t('exceptions:Announcement.TargetTranslationMissing');
      case ControllerExceptionCodes.Code_Announcement_TranslationNotReviewed:
        return t('exceptions:Announcement.TranslationNotReviewed');
      case ControllerExceptionCodes.Code_Announcement_ExternalImage:
        return t('exceptions:Announcement.ExternalImage');
      case ControllerExceptionCodes.Code_Announcement_OtherMedia:
        return t('exceptions:Announcement.OtherMedia');
      case ControllerExceptionCodes.Code_Announcement_ImageUnknown:
        return t('exceptions:Announcement.ImageUnknown');
      case ControllerExceptionCodes.Code_Announcement_ImageInUse:
        return t('exceptions:Announcement.ImageInUse');
      case ControllerExceptionCodes.Code_Announcement_ImageMissing:
        return t('exceptions:Announcement.ImageMissing');
      case ControllerExceptionCodes.Code_Announcement_ImageType:
        return t('exceptions:Announcement.ImageType');
      case ControllerExceptionCodes.Code_Announcement_ImageTooLarge:
        return t('exceptions:Announcement.ImageTooLarge');
      case ControllerExceptionCodes.Code_Announcement_ImageTooManyPixels:
        return t('exceptions:Announcement.ImageTooManyPixels');
      case ControllerExceptionCodes.Code_Announcement_ImageTooManyFrames:
        return t('exceptions:Announcement.ImageTooManyFrames');
      case ControllerExceptionCodes.Code_OutputLocation_NotADocumentLibrary:
        return t('exceptions:OutputLocation.NotADocumentLibrary');
      case ControllerExceptionCodes.Code_OutputLocation_ProviderNotAllowed:
        return t('exceptions:OutputLocation.ProviderNotAllowed');
      case ControllerExceptionCodes.Code_OutputLocation_TemplateNotInLocation:
        return t('exceptions:OutputLocation.TemplateNotInLocation');
      case ControllerExceptionCodes.Code_OutputLocation_TemplateNotAllowed:
        return t('exceptions:OutputLocation.TemplateNotAllowed');
      case ControllerExceptionCodes.Code_OutputLocation_InvalidFormat:
        return t('exceptions:OutputLocation.InvalidFormat');
      case ControllerExceptionCodes.Code_OutputLocation_NotATemplate:
        return t('exceptions:OutputLocation.NotATemplate');
      case ControllerExceptionCodes.Code_OutputLocation_NotBound:
        return t('exceptions:OutputLocation.NotBound');
      case ControllerExceptionCodes.Code_OutputLocation_NoTemplateSettings:
        return t('exceptions:OutputLocation.NoTemplateSettings');
      default:
        return t('exceptions:General.UnknownError');
    }
  }
}
